import { useContext } from 'react';

import { OperationFormContentContext } from './operationFormContentContext';

export const useOperationFormContentContext = () => {
  const context = useContext(OperationFormContentContext);
  if (!context) {
    throw new Error(
      'useOperationFormContentContext must be used within an OperationFormContentProvider'
    );
  }
  return context;
};
